// Angular dependencies
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Import vendor modules
import { NgxPopperModule } from 'ngx-popper';

// Pages component
import { ShareComponent } from './share.component';
import { LocationBackComponent } from './location-back.component';
import { SkillIconPipe } from './skill-icon.pipe';
import { CommanderComponent } from './commander.component';
import { OperatorComponent } from './operator.component';
import { ExecutorComponent } from './executor.component';
import { SkillComponent } from './skill.component';

@NgModule({
  imports: [
    CommonModule,

    // Vendors
    NgxPopperModule.forRoot({
       disableDefaultStyling: true,
       placement: 'bottom'
    }),
  ],
  exports: [
    ShareComponent,
    LocationBackComponent,
    SkillIconPipe,
    CommanderComponent,
    OperatorComponent,
    ExecutorComponent,
    SkillComponent
  ],
  declarations: [
    ShareComponent,
    LocationBackComponent,
    SkillIconPipe,
    CommanderComponent,
    OperatorComponent,
    ExecutorComponent,
    SkillComponent
  ],
  providers: [
  ]
})
export class CoreModule {
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/core.module/core.module.ts